import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { changePasswordStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePassword";
import { css } from "styled-components";

changePasswordStyles.passwordGridContainer = mergeToNew(changePasswordStyles.passwordGridContainer, {
    css: css`
        margin: 0;
    `
});

changePasswordStyles.userInformationTitle = mergeToNew(changePasswordStyles.userInformationTitle, {
    css: css`
        margin: 1rem 0;
    `
});